// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZXep","icon":"styles_icon__3XyLT"};